import { render, staticRenderFns } from "./BusinessDiscovery.vue?vue&type=template&id=150ac398&"
import script from "./BusinessDiscovery.vue?vue&type=script&lang=js&"
export * from "./BusinessDiscovery.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDiscovery.vue?vue&type=style&index=0&id=150ac398&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports